import React from 'react';
import { TrustBar } from './TrustBar';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
export const GuaranteeSection: React.FC = () => {
  return <section className="bg-white pt-16" data-id="element-112">
      <div className="max-w-4xl mx-auto px-4 mb-16" data-id="element-113">
        <div className="bg-gradient-to-br from-blue-50 to-white border-2 border-blue-100 rounded-3xl p-8 md:p-12 shadow-lg flex flex-col md:flex-row items-center gap-8" data-id="element-114">
          <div className="flex-shrink-0 relative" data-id="element-115">
            <div className="w-32 h-32 bg-blue-600 rounded-full flex items-center justify-center shadow-xl border-4 border-white" data-id="element-116">
              <div className="text-center text-white" data-id="element-117">
                <ShieldCheck className="w-12 h-12 mx-auto mb-1" data-id="element-118" />
                <span className="block font-black text-xl leading-none" data-id="element-119">
                  45 DÍAS
                </span>
                <span className="block text-[10px] font-bold uppercase tracking-wider" data-id="element-120">
                  Garantía
                </span>
              </div>
            </div>
          </div>

          <div data-id="element-121">
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-4" data-id="element-122">
              Garantía de Satisfacción Total
            </h3>
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-123">
              Estamos tan seguros de la calidad de este material que asumimos
              todo el riesgo. Tenés 45 días completos para revisar todo el pack,
              aplicar los ejercicios y usar las plantillas.
            </p>
            <ul className="space-y-2" data-id="element-124">
              <li className="flex items-start space-x-2" data-id="element-125">
                <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-126" />
                <span className="text-gray-700 font-medium" data-id="element-127">
                  Si no te ahorra tiempo en la preparación de clases...
                </span>
              </li>
              <li className="flex items-start space-x-2" data-id="element-128">
                <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-129" />
                <span className="text-gray-700 font-medium" data-id="element-130">
                  Si no te ayuda a organizar mejor a tus alumnos...
                </span>
              </li>
              <li className="flex items-start space-x-2" data-id="element-131">
                <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-132" />
                <span className="text-gray-700 font-medium" data-id="element-133">
                  O si simplemente decidís que no es para vos...
                </span>
              </li>
            </ul>
            <p className="mt-4 font-bold text-gray-900" data-id="element-134">
              Te devolvemos el 100% de tu dinero. Sin preguntas, sin
              complicaciones.
            </p>
          </div>
        </div>
      </div>

      <TrustBar data-id="element-135" />
    </section>;
};